import React, { useEffect } from 'react';
import { useApp } from '../data/ColisContext';

const COLORS = {
  success: '#10B981',
  error:   '#EF4444',
  info:    '#4F46E5',
};

const ICONS = {
  success: '✅',
  error:   '❌',
  info:    'ℹ️',
};

export default function Toast() {
  const { toast, dismissToast } = useApp();

  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(dismissToast, 3500);
    return () => clearTimeout(t);
  }, [toast, dismissToast]);

  if (!toast) return null;

  return (
    <div style={{
      position:    'fixed',
      top:         24,
      right:       24,
      zIndex:      9999,
      background:  'white',
      borderRadius: 12,
      padding:     '14px 20px',
      boxShadow:   '0 8px 32px rgba(0,0,0,0.15)',
      borderLeft:  `4px solid ${COLORS[toast.type] || COLORS.info}`,
      display:     'flex',
      alignItems:  'center',
      gap:         10,
      maxWidth:    340,
      animation:   'slideIn 0.3s ease-out',
    }}>
      <span style={{ fontSize: 18 }}>{ICONS[toast.type] || ICONS.info}</span>
      <span style={{ color: '#1e293b', fontWeight: 500, fontSize: 14, flex: 1 }}>
        {toast.message}
      </span>
      <button
        onClick={dismissToast}
        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', fontSize: 18, lineHeight: 1 }}
      >
        ×
      </button>
    </div>
  );
}
